<template>
  <List :archive="2"></List>
</template>

<script>
import List from './index.vue'

export default {
  components: {
    List,
  },
}
</script>